import {
  HHBox,
  HHIconButton,
  HHStack,
  HHTypography,
} from '@hinge-health/react-component-library';
import PushPin from '@mui/icons-material/PushPin';
import PushPinOutlined from '@mui/icons-material/PushPinOutlined';
import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

interface QuickActionButtonProps {
  label: string;
  ariaLabel: string;
  Icon: React.ElementType;
  onClick: () => void;
  pinned?: boolean;
  onTogglePin?: () => void;
}

export const QuickActionButton = ({
  label,
  ariaLabel,
  Icon,
  onClick,
  pinned = false,
  onTogglePin,
}: QuickActionButtonProps): JSX.Element => (
  <HHBox
    data-testid={`quick-action-${ariaLabel.replace(/\s+/g, '-')}`}
    sx={{
      position: 'relative',
      '&:hover .MuiIconButton-root': {
        opacity: 1,
      },
    }}
  >
    <HHStack
      role="button"
      aria-label={ariaLabel}
      onClick={onClick}
      direction="column"
      alignItems="center"
      justifyContent="center"
      spacing={1}
      sx={(theme): SystemStyleObject<Theme> => ({
        backgroundColor: theme.palette.background.default,
        borderRadius: 2,
        padding: 3,
        cursor: 'pointer',
        transition: 'background-color 0.2s',
        '&:hover': {
          backgroundColor: theme.palette.action.hover,
        },
      })}
    >
      <Icon
        sx={{
          fontSize: 32,
          color: (theme: Theme) => theme.palette.primary.dark,
        }}
      />
      <HHTypography
        hhVariant="body"
        sx={{
          textAlign: 'center',
          color: (theme: Theme) => theme.palette.primary.dark,
        }}
      >
        {label}
      </HHTypography>
    </HHStack>
    {onTogglePin && (
      <HHIconButton
        hhVariant="variant-bypass"
        aria-label={pinned ? `unpin ${label}` : `pin ${label}`}
        onClick={(e): void => {
          e.stopPropagation();
          onTogglePin();
        }}
        size="small"
        sx={{
          position: 'absolute',
          top: 4,
          right: 4,
          opacity: pinned ? 1 : 0,
          transition: 'opacity 0.2s',
          padding: 0.5,
          color: (theme: Theme) => theme.palette.primary.dark,
        }}
      >
        {pinned ? (
          <PushPin sx={{ fontSize: 16 }} />
        ) : (
          <PushPinOutlined sx={{ fontSize: 16 }} />
        )}
      </HHIconButton>
    )}
  </HHBox>
);
